<template>
  <div id="app">
    <v-app>
      <v-app-bar
              color="deep-purple accent-4"
              dense
              dark
              fixed=true
      >
        <v-toolbar-title>Hyundai Accueil RDV</v-toolbar-title>
        <v-spacer></v-spacer>
        <router-link v-if="loggedIn && ['ListeRdv'].indexOf($route.name) == -1" to="/ListeRdv"><v-btn small rounded>Liste RDV</v-btn></router-link>
        <v-btn v-if="loggedIn && ['ListeRdv'].indexOf($route.name) > -1" small rounded  icon @click="refresh" class="mr-4"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn v-if="loggedIn && ['ListeRdv'].indexOf($route.name) > -1" small rounded  icon @click="search" class="mr-4"><v-icon>mdi-magnify</v-icon></v-btn>
        <v-btn v-if="loggedIn && ['ListeRdv'].indexOf($route.name) > -1" small rounded  icon @click="addRdv" class="mr-4"><v-icon>mdi-playlist-plus</v-icon></v-btn>
        <v-btn v-if="loggedIn" small rounded  icon @click="logout" class="mr-4"><v-icon>mdi-logout</v-icon></v-btn>
      </v-app-bar>
      <router-view class="mt-10" />
    </v-app>
  </div>
</template>

<script>
  import { authComputed } from '@/store/helpers.js'
  export default {
    name: 'MenuBar',
    methods: {
      logout() {
        if(confirm('Etes-vous sûr de vouloir vous déconnecter ?')) {
          this.$store
                  .dispatch('logout',)
                  .then({})
                  .catch(error => {
                    console.log(error)
                  })
        }
      },
      refresh() {
        location.reload()
      },
      search() {
        this.$store.commit('SET_SEARCH_MODE')
      },
      addRdv() {
        this.$router.push({name:'AddRdv'})
      }
    },
    computed: {
      ...authComputed,
    }


  }
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>
